import './main.css'
import '../App.css'
import { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { Copy, UserPlus } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from './common/function';
import { CopyToClipboard } from "react-copy-to-clipboard/src";

import WebApp from '@twa-dev/sdk'
import { changeAlramModal, checkDuplicateLogins } from '../store';
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from 'framer-motion';
import ProgressBar from '@ramonak/react-progress-bar';

function Friends() {
    const { t } = useTranslation();
    let JWT = useSelector((state) => { return state.JWT.value })
    let myData = useSelector((state) => { return state.myData })
    let dispatch = useDispatch()

    const [message, setMessage] = useState("");
    const [friendList, setFriendList] = useState([])
    const [friendGive, setFriendGive] = useState([])

    const thresholds = [50];
    const maxInvite = thresholds[thresholds.length - 1];
    const [invitedCount, setInvitedCount] = useState(0);

    const shareLink = useCallback(() => {
        const envShareUrl = `${process.env.REACT_APP_FRIENDURL}${myData.id}`;

        if (null != envShareUrl && '' !== envShareUrl) {
            const shareText = encodeURIComponent("SAYCOIN의 공유 링크");
            const shareUrl = encodeURIComponent(envShareUrl);
            const url = `https://t.me/share/url?text=${shareText}&url=${shareUrl}`;

            try {
                WebApp.openTelegramLink(url);
            } catch (error) {
                console.log(`Error openTelegramLink`, error)
            }
        }
    }, [])

    useEffect(() => {
        FriendData()
    }, [])

    const FriendData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/user/friend', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                const friends = tmp.data.friend ?? [];
                // 최대 50개까지만 잘라서 저장
                const limitedFriends = friends.length > 50
                    ? friends.slice(0, 50)
                    : friends;

                setFriendList(friends);
                setFriendGive(tmp.data.give ?? 0);
                setInvitedCount(friends.length);
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    return (
        <div className='main notheader'>
            <MessageModal message={message} />
            <div className='friend'>
                <div className='settings-header'>{t('friend_0')}</div>
                <div className='settings-subheader'>{t('friend_1')}</div>
                <div className=''>
                    <div className='friend-list' style={{ display: "block", padding: "12px 15px" }}>
                        <div className='friend-list' style={{ padding: "0", margin: "0" }}>
                            <img src='/newImg/icon_goldenbox_big.png' style={{ width: "50px" }} />
                            <div className='friend-list-text' style={{ width: "100%", paddingLeft: "10px" }}>
                                <div style={{ fontWeight: '500' }}>{t('friend_2')}</div>
                                <div className='friend-list-text-1'>
                                    <FontAwesomeIcon icon={faCircle} style={{ color: "#f8d458", fontSize: "5px", paddingRight: "3px", paddingTop: "3px" }} />
                                    <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "1px" }} />
                                    <span style={{ color: '#f8d458', marginRight: "5px" }}>+<span className='fontNumber'>{changeNum(Number(friendGive))}</span></span>
                                    <span style={{ paddingBottom: "1px" }}>{t('friend_3')}</span>
                                </div>
                                <div style={{ position: 'relative', width: '100%', marginTop: "5px" }}>
                                    <ProgressBar
                                        completed={invitedCount}
                                        maxCompleted={maxInvite}
                                        customLabel={""}
                                        labelColor="transparent"
                                        bgColor="#5863FF"
                                        baseBgColor="#373737"
                                        height="20px"
                                        animateOnRender={false}
                                        transitionDuration="0s"
                                        transitionTimingFunction="linear"
                                        borderRadius="3px"
                                    />


                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0, left: 0,
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#FFFFFF',
                                            fontWeight: 500,
                                            fontSize: "12px"
                                        }}
                                    >
                                        {invitedCount} / 50
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='friend-list-1'>
                        <div className='friend-list-1-1'>
                            <div style={{ fontWeight: "500" }}>{t('friend_4')} ({friendList.length})</div>
                            {/* <div><FontAwesomeIcon icon={faArrowsRotate} fontSize={22} /></div> */}
                        </div>
                        {
                            friendList.length === 0
                                ?
                                <div className='friend-list-1-2'>
                                    {t('friend_5')}
                                </div>
                                :
                                friendList.map(function (a, i) {
                                    return (
                                        <div key={i}>
                                            <FriendItem key={i} item={a} />
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
                <div className='friend-list-2'>
                    <div className='friend-list-2-1'>
                        <motion.div
                            className="friend-list-2-btn"
                            onClick={shareLink}
                            animate={{ scale: [1, 1.05, 1] }} // 키프레임으로 크기 변경
                            transition={{ duration: 1.5, repeat: Infinity, repeatType: "loop" }} // 무한 반복 설정
                        >
                            {t('friend_2')}
                            <UserPlus size={15} style={{ marginLeft: '5px' }} />
                        </motion.div>
                    </div>
                    {/* <div className='friend-list-2-btn' onClick={shareLink}>{t('friend_2')} <UserPlus size={15} style={{ marginLeft: '5px' }} /></div> */}
                    <div className='friend-list-2-icon'>
                        <CopyToClipboard text={`${process.env.REACT_APP_FRIENDURL}${myData.id}` ?? ""}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { setMessage({ "code": 0, "msg": t('message_4') }); dispatch(changeAlramModal()) }}>
                                <Copy size={22} />
                            </div>
                        </CopyToClipboard>
                    </div>
                </div>
            </div>
        </div>
    )
}

function FriendItem({ item }) {
    return (
        <div className='friend-list-1-3'>
            <div className='friend-list-1-3-1'>
                <img src={process.env.REACT_APP_API + item.skin_img} style={{ height: "55px" }} />
                <div>
                    <div>{item.user_name}</div>
                    <div style={{ fontWeight: '400', fontSize: '13px', color: '#8d8d8d' }}>{item.friend_id}</div>
                </div>
            </div>
            <div className='friend-list-1-3-2'>
                <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px" }} />
                <div className='fontNumber' style={{ display: 'flex', alignItems: "center" }}>
                    <span>{changeUnits(item.user_gold ?? 0)}</span>
                </div>
            </div>
        </div>
    )
}

export default Friends;